import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { AppHeader } from "@/components/layout/AppHeader";
import { useSectionTheme } from "@/hooks/useSectionTheme";

export function AppLayout() {
  const { session, loading } = useAuth();
  const location = useLocation();
  const module = useSectionTheme(location.pathname);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <p className="text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (!session) return <Navigate to="/auth" replace />;

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0">
          <AppHeader />
          <main
            key={location.pathname}
            data-module={module}
            className="section-bg flex-1 px-4 py-6 sm:px-6 sm:py-8 lg:px-10 lg:py-10 page-fade-in min-w-0"
          >
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
